import React from 'react';

import { get as getConfig } from '@lumapps/constants';

/** Get current instance logo URL */
export const useInstanceLogo = (): string => {
    return React.useMemo(() => {
        const { isDev, defaultLogoUrl, logo } = getConfig();
        return isDev || !logo ? defaultLogoUrl : logo;
    }, []);
};
